import { Bill } from '@modules/finance/pages/charge-internet/definitions/charge-internet.model';
import { Plan } from '@modules/services/definitions/plans.model';
import { Product } from '@modules/warehouse/pages/products/models/product.model';

export interface ICreateInstallation {
  identification: string;
  fullName: string;
  address: string;
  landlinePhone: string;
  cellphone: string;
  email: string;
  city: string;
  installationDate?: string;
  observations: string;
  zoneId: number;
  quadrilleId: number;
  status?: installationStatus;
  isFinanced?: boolean;
  quotas?: number;
  planId?: number;
  seal?: string;
  isPromo?: boolean;
  routerId?: string;
  price?: number;
  companyOwnerId?: number;
  isRented?: boolean;
}

export interface IInstallation {
  id: number;
  identification: string;
  fullName: string;
  address: string;
  landlinePhone: string;
  cellphone: string;
  email: string;
  city: string;
  CPE: string;
  installationDate: string;
  observations: string;
  zoneId: number;
  installerId: number;
  isAccepted: boolean;
  zone: {
    id: number;
    zoneAddress: string;
    stateId: number;
    municipalityId: number;
    state: {
      id: number;
      name: string;
    };
    municipality: {
      id: number;
      name: string;
    };
  };
  quadrille: {
    id: number;
    name: string;
    vehicles: {
      id: number;
      plate: string;
      model: string;
      brand: string;
      color: string;
      year: number;
    }[];
    installers: {
      id: number;
      fullName: string;
      phoneNumber: string;
      address: string;
      ci: string;
    }[];
  };
  seal: string;
  fiberInit: number;
  fiberEnd: number;
  fiberMetersAreKnown: boolean;
  portNapId: number;
  status: installationStatus;
  boxNapId: number;
  boxNap: any;
  products?: Product[];
  ipV4?: string;
  routerId?: string;
  planId?: number;
  longitude?: number;
  latitude?: number;
  ip?: string;
  mac?: string;
  statusMigration?: installationStatusMigration;
  isFinanced?: boolean;
  quotas?: number;
  isPromo?: boolean;
  plan?: Plan;
  price?: number;
  bill?: Bill | null;
  companyOwnerId?: number;
  isRented?: boolean;
}

export enum installationStatus {
  PENDING = 'pending',
  DONE = 'done',
  CANCELED = 'canceled',
  NOTINSTALLED = 'notInstalled',
}

export enum installationStatusMigration {
  COMPLETE = 'complete',
  SOME_MISSING = 'someMissing',
  A_LOT_MISSING = 'aLotMissing',
}
